export default (node) => {
  /**
   * Data + elements
   */
  const courseDetailsButton = node.querySelector(
    '[data-button-course-details]'
  );

  /**
   * Functions
   */
  const showCourseDetails = () => {
    // save in local storage that the user has clicked the button course details
    const lineItemKey = courseDetailsButton.getAttribute('data-line-item-key');
    localStorage.setItem('courseDetails', lineItemKey);
    // get the url
    const url = courseDetailsButton.getAttribute('data-button-course-details');
    // redirect to the url
    window.location.href = url;
  };

  /**
   * Init
   */
  const init = () => {
    if (courseDetailsButton) {
      courseDetailsButton.addEventListener('click', showCourseDetails);
    }
  };

  init();
};
